export const CURRENCY = "currency";
